module.exports = __webpack_public_path__ + "img/d2.dae0682d.png";